import React, { ReactNode } from 'react';
import styled from 'styled-components';
import SecondaryNavHeader from './SecondaryNavHeader';
import ScrollableWrapper from '../ScrollableWrapper/ScrollableWrapper';

interface IProps {
  children: ReactNode;
  heading?: string;
  headingIsBeta?: boolean;
  warning?: string;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  visibility: visible;
  padding: 16px;
  gap: 2px;
`;

const ContentWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  row-gap: 4px;
  max-height: 100%;
  padding-top: 16px;
  overflow-y: auto;
`;

export default ({ children, heading, headingIsBeta, warning }: IProps) => {
  return (
    <Container>
      {heading && (
        <SecondaryNavHeader
          title={heading}
          isBeta={headingIsBeta}
          warningMessage={warning}
        />
      )}
      <ScrollableWrapper>
        <ContentWrapper>{children}</ContentWrapper>
      </ScrollableWrapper>
    </Container>
  );
};
